import logo_daicus from '../assets/logo_daicus.png'
import { List, Button, ListItem, ListItemButton } from '@mui/material'
import { Link, useNavigate, useLocation } from 'react-router-dom'

function Header() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleScrollNavigation = (sectionId) => {
        if (location.pathname === '/') {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            navigate('/', { state: { scrollTo: sectionId } });
        }
    };

    return (
        <header style={{ 
            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 999, backgroundColor: 'rgba(0, 0, 0, 0.9)', 
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem 4rem', maxWidth: '1150px', margin: '0 auto' 
            }}>
            <div>
                <img src={logo_daicus} alt="DAICUS" style={{ height: '70px' }}/>
            </div>

            <nav style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', borderRadius: '2rem', padding: '0.1rem 1rem'}}>
                <List sx={{ display: 'flex', alignItems: 'center', listStyle: 'none', margin: 0, padding: 0 }}>
                    <ListItem>
                        <ListItemButton
                            component={Link}
                            to='/'
                            sx={{
                                color: '#999', '&:hover': { color: '#fff' }
                            }}
                            onClick={() => handleScrollNavigation('cover')}
                        >
                            Home
                        </ListItemButton>
                    </ListItem>
                    <ListItem>
                        <ListItemButton 
                            sx={{ 
                                color: '#999', '&:hover': {color: '#fff'} 
                            }}
                            onClick={() => handleScrollNavigation('products')}
                            >
                            Products
                        </ListItemButton>
                    </ListItem>
                    <ListItem>
                        <ListItemButton
                            sx={{ 
                                color: '#999', '&:hover': {color: '#fff'} 
                            }}
                            onClick={() => handleScrollNavigation('testimonials')}
                            >
                            Solutions
                        </ListItemButton>
                    </ListItem>
                    <ListItem>
                        <ListItemButton
                            sx={{ 
                                color: '#999', '&:hover': {color: '#fff'} 
                            }}
                            onClick={() => handleScrollNavigation('contact')}
                            >
                            Company
                        </ListItemButton>
                    </ListItem>
                    <ListItem>
                        <ListItemButton
                            component={Link}
                            to='/blog'
                            sx={{
                                color: '#999', '&:hover': { color: '#fff' }
                            }}                        
                        >
                            Blogs
                        </ListItemButton>
                    </ListItem>
                </List>
            </nav>

            <div style={{ marginLeft: '1rem'}}>
                <Button
                    sx={{ 
                        backgroundColor: '#6e44ff', 
                        border: '1px solid #6e44ff', 
                        borderRadius: '0.5rem',
                        textTransform: 'none',
                        color: '#fff',
                        paddingLeft: 2,
                        paddingRight: 2,
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: '#9a64ff',
                            transform: 'scale(1.02)',
                        },
                    }}
                    onClick={() => handleScrollNavigation('contact')}
                    >
                        Free Trial
                </Button>
            </div>
        </header>
    )
}

export default Header